import { render, staticRenderFns } from "./CrpDashboard.vue?vue&type=template&id=844ddff2&"
import script from "./CrpDashboard.vue?vue&type=script&lang=js&"
export * from "./CrpDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CrpDashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports